'use client';

import React from 'react';
import { Kbd } from '@/shared/ui/shadcn/kbd';
import { cn } from '@/shared/lib/cn';

interface KeyboardHintProps {
  keys: string[];
  className?: string;
  show?: boolean;
}

export default function KeyboardHint({
  keys,
  className = '',
  show = true,
}: KeyboardHintProps) {
  if (!show) return null;

  const isMac =
    typeof navigator !== 'undefined' &&
    navigator.platform.toUpperCase().indexOf('MAC') >= 0;

  const formatKey = (key: string) => {
    // Replace platform-specific keys
    if (key === 'cmd' || key === 'ctrl') return isMac ? '⌘' : 'Ctrl';
    if (key === 'shift') return '⇧';
    if (key === 'alt') return isMac ? '⌥' : 'Alt';
    if (key === 'enter') return '⏎';
    if (key === 'escape') return 'Esc';
    return key.toUpperCase();
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-card-meta text-muted-foreground',
        className
      )}
    >
      {keys.map((key, index) => (
        <React.Fragment key={key}>
          {index > 0 && <span className="text-muted-foreground/60">+</span>}
          <Kbd>{formatKey(key)}</Kbd>
        </React.Fragment>
      ))}
    </span>
  );
}
